// extracted by mini-css-extract-plugin
export default {"formHeading":"sR-z","form":"tR-z","submitBtn":"uR-z","disabled":"vR-z","input":"wR-z","error":"xR-z","submitMsg":"yR-z","signIn":"zR-z"};